import type { ChartResponse } from '../../redux/config/chart-data';
import type { WidgetConfigurationData } from '../../redux/config/widgetApi';
import { CombineFirstSecondFields } from '../common-commands/combine-first-second-fields';
import type { FirstSecondFieldsDataType } from '../common-commands/common-data.interface';
import { DeleteUndefinedAttributes } from '../common-commands/delete-undefined-attributes';
import { FirstFields } from '../common-commands/first-fields';
import { getTopAmountToDisplay } from '../common-commands/get-top-items-display';
import { HideBlankCategory } from '../common-commands/hide-blank-category';
import { SecondFields } from '../common-commands/second-fields';
import { SortByField } from '../common-commands/sort-by-field';
import { SortByValueReturnTop } from '../common-commands/sort-column-return-top';
import { SortOrderKeys } from '../common-commands/sort-order-keys';
import type { DataCommandResponse, IDataCommand, IDataCommandFactory } from '../data-transformer.interface';

export class BarChartSecondFieldsCommandFactory implements IDataCommandFactory {
  private currentCommandIndex = 0;
  private readonly commands: Array<
    IDataCommand<FirstSecondFieldsDataType, WidgetConfigurationData, FirstSecondFieldsDataType>
  >;

  constructor(configurationData: WidgetConfigurationData) {
    this.commands = [new FirstFields(), new SecondFields(), new CombineFirstSecondFields()];
    if (configurationData.widgetConfig?.hideBlankCategory) {
      this.commands.push(new HideBlankCategory());
    }
    if (getTopAmountToDisplay(configurationData) !== -1) {
      this.commands.push(new SortByValueReturnTop<ChartResponse>());
    } else if (configurationData?.widgetConfig?.sortOrder) {
      this.commands.push(new SortOrderKeys());
    } else {
      this.commands.push(new SortByField<ChartResponse[]>());
    }
    this.commands.push(new DeleteUndefinedAttributes<ChartResponse>());
  }

  getNextCommand<TIn, TInConfig, TOut>(): DataCommandResponse<TIn, TInConfig, TOut> | undefined {
    const command = this.commands[this.currentCommandIndex] as IDataCommand<TIn, TInConfig, TOut>;
    return (
      command && {
        command,
        commandIndex: this.currentCommandIndex++,
      }
    );
  }
}
